import React from 'react';
import { Link } from 'react-router-dom';
import ZoomGallery from '../components/ZoomGallery';
import DressCTA from './DressCTA';
import { sortedDressImages } from '../data/categoryImageUrl';
import { responsiveImage, CARD_WIDTHS } from '../data/responsiveImage';
import { GOLD, GOLD_LT, CREAM, INK } from '../theme';

export default function DressDetailView({ category, dress, prevDress, nextDress, others, imageUrl }) {
  const images = sortedDressImages(dress);

  return (
    <div style={{ fontFamily: "'Cormorant Garamond', serif", background: INK, color: '#efe4d2' }}>
      <section style={{ padding: 'clamp(28px,5vh,48px) clamp(16px,3vw,48px) 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
        <nav aria-label="Breadcrumb" style={{ fontSize: 13, letterSpacing: '.14em', textTransform: 'uppercase', color: 'rgba(239,228,210,.55)' }}>
          <Link to="/#categories" style={{ color: 'inherit', textDecoration: 'none' }}>Home</Link>
          <span aria-hidden="true" style={{ fontSize: 18, margin: '0 8px' }}>›</span>
          <Link to="/categories" style={{ color: 'inherit', textDecoration: 'none' }}>Categories</Link>
          <span aria-hidden="true" style={{ fontSize: 18, margin: '0 8px' }}>›</span>
          <Link to={`/categories/${category.slug}`} style={{ color: 'inherit', textDecoration: 'none' }}>{category.name}</Link>
          <span aria-hidden="true" style={{ fontSize: 18, margin: '0 8px' }}>›</span>
          <span aria-current="page" style={{ color: CREAM }}>{dress.name}</span>
        </nav>
        <div style={{ display: 'flex', gap: 20, fontSize: 13, letterSpacing: '.14em', textTransform: 'uppercase' }}>
          {prevDress && <Link to={`/categories/${category.slug}/${prevDress.slug}`} style={{ color: GOLD_LT, textDecoration: 'none' }}>← Previous</Link>}
          {nextDress && <Link to={`/categories/${category.slug}/${nextDress.slug}`} style={{ color: GOLD_LT, textDecoration: 'none' }}>Next →</Link>}
        </div>
      </section>

      <section style={{ padding: 'clamp(20px,3vh,32px) clamp(16px,3vw,48px) clamp(60px,9vh,100px)', display: 'flex', flexWrap: 'wrap', gap: 'clamp(32px,5vw,64px)' }}>
        <div style={{ flex: '1 1 420px', minWidth: 0, maxWidth: 560 }}>
          <ZoomGallery images={images} imageUrl={imageUrl} altBase={dress.name} />
        </div>

        <div style={{ flex: '1 1 320px', minWidth: 0, paddingTop: 4 }}>
          <div style={{ fontWeight: 600, fontSize: 14, letterSpacing: '.36em', textTransform: 'uppercase', color: GOLD, marginBottom: 14 }}>{category.name}</div>
          <h1 style={{ fontFamily: "'Bodoni Moda', serif", fontWeight: 500, fontStyle: 'italic', fontSize: 'clamp(42px,5vw,64px)', lineHeight: 1, margin: '0 0 22px', color: CREAM }}>{dress.name}</h1>

          <DressCTA dress={dress} categorySlug={category.slug} />

          {dress.description && (
            <div style={{ marginTop: 30, paddingTop: 30, borderTop: '1px solid rgba(201,162,75,.2)' }}>
              <div style={{ fontWeight: 600, fontSize: 13, letterSpacing: '.2em', textTransform: 'uppercase', color: GOLD_LT, marginBottom: 10 }}>Description</div>
              <p style={{ fontSize: 16, lineHeight: 1.75, color: 'rgba(239,228,210,.8)' }}>{dress.description}</p>
            </div>
          )}

          {dress.details && dress.details.length > 0 && (
            <div style={{ marginTop: 26 }}>
              <div style={{ fontWeight: 600, fontSize: 13, letterSpacing: '.2em', textTransform: 'uppercase', color: GOLD_LT, marginBottom: 14 }}>Product Details</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                {dress.details.map((d, i) => (
                  <div key={`${d}-${i}`} style={{ display: 'flex', alignItems: 'baseline', gap: 12, fontSize: 15, color: 'rgba(239,228,210,.75)' }}>
                    <span style={{ color: GOLD_LT }}>—</span>{d}
                  </div>
                ))}
              </div>
            </div>
          )}

          {dress.note && <p style={{ marginTop: 20, fontSize: 14, color: 'rgba(239,228,210,.55)', fontStyle: 'italic' }}>{dress.note}</p>}

          {(dress.unstitchedPrice || dress.sizedPrice) && dress.shippingTime && (
            <p style={{ marginTop: 14, fontSize: 14, color: 'rgba(239,228,210,.55)' }}><strong style={{ color: CREAM }}>Shipping time:</strong> {dress.shippingTime}</p>
          )}
        </div>
      </section>

      {others.length > 0 && (
        <section style={{ padding: 'clamp(50px,8vh,80px) 0 clamp(70px,10vh,110px)', borderTop: '1px solid rgba(201,162,75,.2)' }}>
          <div style={{ padding: '0 clamp(16px,3vw,48px)', marginBottom: 36 }}>
            <h2 style={{ fontFamily: "'Bodoni Moda', serif", fontWeight: 500, fontStyle: 'italic', fontSize: 'clamp(28px,3.4vw,40px)', margin: 0, color: CREAM }}>You may also like</h2>
          </div>
          <div className="ij-car" style={{ display: 'flex', gap: 24, overflowX: 'auto', padding: '0 clamp(16px,3vw,48px)' }}>
            {others.map((d) => {
              const thumb = sortedDressImages(d)[0];
              return (
                <Link key={d.slug} to={`/categories/${category.slug}/${d.slug}`} style={{ flex: '0 0 auto', width: 220, textDecoration: 'none', color: 'inherit' }}>
                  <div style={{ position: 'relative', width: '100%', aspectRatio: '3 / 4', background: 'repeating-linear-gradient(135deg,#2a2016,#2a2016 14px,#231a11 14px,#231a11 28px)', border: '1px solid rgba(201,162,75,.4)', overflow: 'hidden' }}>
                    {/* alt duplicated the name printed directly beneath it. */}
                    {thumb && <img {...responsiveImage(imageUrl(thumb), CARD_WIDTHS, '220px')} alt="" loading="lazy" decoding="async" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'top' }} />}
                  </div>
                  <div style={{ marginTop: 12, fontFamily: "'Bodoni Moda', serif", fontSize: 20, color: CREAM }}>{d.name}</div>
                </Link>
              );
            })}
          </div>
        </section>
      )}
    </div>
  );
}
